export default __webpack_public_path__ + "static/media/u-12.bd0b03a7.png";